export const COLLECTIONS = {
  BOOKMARKS: "bookmarks",
  USERS: "users",
  FOLDERS: "folders",
};

export const HOME_TABS = [
  {
    id: "bookmarks",
    name: "My bookmarks",
  },
  {
    id: "shared",
    name: "Shared with me",
  },
  {
    id: "about",
    name: "About",
    align: "right",
  },
];

export const DUMMY_ITEMS = [
  {
    "id": "fArXvFGZXE5AKDBOR0UB",
    "url": "https://india.in",
    "description": "I love my India. We love india",
    "_updatedAt": {
      "seconds": 1688314269,
      "nanoseconds": 999000000
    },
    "createdBy": "GDEQnKEmOtceCb2R8T8HT1r6lRM2",
    "folderId": "",
    "_createdAt": {
      "seconds": 1682867673,
      "nanoseconds": 485000000
    },
    "title": "India is love"
  },
  {
    "id": "i7BdL9OtYERZk3kLjeIt",
    "folderId": "r4UZDIBL189JV4b7q6qK",
    "createdBy": "GDEQnKEmOtceCb2R8T8HT1r6lRM2",
    "title": "My Yahoo!",
    "_updatedAt": {
      "seconds": 1688356512,
      "nanoseconds": 231000000
    },
    "url": "https://yahoo.com",
    "_createdAt": {
      "seconds": 1682849887,
      "nanoseconds": 314000000
    },
    "description": "Yahoo is good"
  },
  {
    "id": "Bm4r0lAbpA538bznyHHv",
    "folderId": "ZDPnrbq5T12kNqFG4Ztv",
    "url": "https://getbootstrap.com/",
    "createdBy": "i0J1UykPZSckMOZnRcNyFjDLw3C2",
    "description": "",
    "_createdAt": {
      "seconds": 1688237002,
      "nanoseconds": 830000000
    },
    "title": "bootstrap"
  },
  {
    "id": "C27So63TsJXC3neWw624",
    "folderId": "sye5cHNQ9glrWNRmxK6N",
    "description": "Use feather icons",
    "_updatedAt": {
      "seconds": 1688314458,
      "nanoseconds": 8000000
    },
    "title": "feather icon",
    "url": "https://feathericons.com/?query=add",
    "_createdAt": {
      "seconds": 1688236729,
      "nanoseconds": 116000000
    },
    "createdBy": "GDEQnKEmOtceCb2R8T8HT1r6lRM2"
  },
  {
    "id": "s8EhpfmcV8A9xiQ6iqYk",
    "_createdAt": {
      "seconds": 1688718961,
      "nanoseconds": 574000000
    },
    "url": "https://yahoo.com",
    "description": "",
    "title": "yahoo",
    "createdBy": "GDEQnKEmOtceCb2R8T8HT1r6lRM2",
    "folderId": "qeJy9PYs31bpoJzF5KbP"
  }
];

export const DUMMY_FOLDERS = [
  {
    "id": "r4UZDIBL189JV4b7q6qK",
    "name": "Folder 2",
    "accessTo": [
      "cmg.dev.projects@gmail.com"
    ]
  },
  {
    "id": "qeJy9PYs31bpoJzF5KbP",
    "_createdAt": {
      "seconds": 1688718960,
      "nanoseconds": 827000000
    },
    "accessTo": [
      "cmgohil07@gmail.com"
    ],
    "createdBy": "GDEQnKEmOtceCb2R8T8HT1r6lRM2",
    "name": "Keval"
  },
  {
    "id": "sye5cHNQ9glrWNRmxK6N",
    "_createdAt": {
      "seconds": 1688234904,
      "nanoseconds": 761000000
    },
    "name": "Lokesh",
    "createdBy": "GDEQnKEmOtceCb2R8T8HT1r6lRM2",
    "accessTo": [
      "cmgohil07@gmail.com"
    ]
  },
  {
    "id": "ZDPnrbq5T12kNqFG4Ztv",
    "name": "ui marks",
    "createdBy": "GDEQnKEmOtceCb2R8T8HT1r6lRM2",
    "_createdAt": {
      "seconds": 1688236727,
      "nanoseconds": 911000000
    },
    "accessTo": []
  }
]

export const DUMMY_AUTH =
{
  "uid": "GDEQnKEmOtceCb2R8T8HT1r6lRM2",
  "email": "cmg.dev.projects@gmail.com",
  "name": "CMG Projects",
  "photoURL": "https://lh3.googleusercontent.com/a/AGNmyxZCUgAO5vi8Ltx-pxJEM1xhrh6ZqcIHQaqiTa2L=s96-c"
}